import * as React from 'react';

interface DialogProps {
  children: React.ReactNode;
  onClose?: () => void;
  variant?: 'panel' | 'centered';
}

export default function Dialog({ children, onClose, variant = 'panel' }: DialogProps) {
  React.useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  return (
    <div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-black/50 transition-opacity" aria-hidden="true" onClick={onClose} />

      {variant === 'panel' ? (
        <div className="pointer-events-none fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex h-screen flex-col items-end justify-center p-4 text-center">
            <div className="pointer-events-auto relative w-full flex-1 grow overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
              {children}
            </div>
          </div>
        </div>
      ) : (
        <div className="pointer-events-none fixed inset-0 z-10 flex items-center justify-center overflow-y-auto">
          <div className="pointer-events-auto w-full max-w-4xl p-4">{children}</div>
        </div>
      )}
    </div>
  );
}
